import "./App.css";
import AllRouter from "./Context/AllRouter";
import React from "react";

function App() {
  return (
    <div className="App">
        <AllRouter />
    </div>
  );
}

export default App;
